module.exports = __webpack_public_path__ + "img/pallets.76b15fc3.svg";